query getLeadsPipelineStatuses($input: GetLeadsPipelineStatusesInput!) {
  leadsPipelineStatuses: getLeadsPipelineStatuses(input: $input) {
    id
    companyId
    name
    position
  }
}
